import SiteService from "../../services/SiteService";
import Vue from "vue";
import OrderService from "../../services/OrderService";
import moment from "moment";

const state = {
  siteId: 0,
  passes: [],
  siteName: "",
  agencyName: "",
  orderDetails: {},
  status: "not started",
  paymentUrl: "",
  tokenInfo: {}
};

const getters = {
  passes: state => state.passes,
  siteId: state => state.siteId,
  siteName: state => state.siteName,
  agencyName: state => state.agencyName,
  status: state => state.status,
  orderDetails: state => state.orderDetails,
  paymentUrl: state => state.paymentUrl,
  tokenInfo: state => state.tokenInfo,
  totalPrice(state) {
    if (state.passes.length === 0) {
      return 0;
    }
    return (
      state.passes
        .map(pass => pass.priceDetails.total)
        .reduce((a, b) => a + b) / 100000
    );
  }
};

const actions = {
  initialize(context) {
    let service = new SiteService();
    service.getSiteById(context.getters.siteId).then(data => {
      context.commit("updateSiteName", data.name);
      context.commit("updateAgencyName", data.agency);
      context.commit("updateStatus", "initialized");
    });
  },

  checkout(context) {
    //create order
    let order = {};
    order.orderDetails = context.getters.orderDetails;
    order.siteId = context.getters.siteId;
    order.parkname = context.getters.siteName;
    context.getters.passes.forEach(pass => {
      pass.description = pass.description + " " + order.parkname;
    });
    order.passes = context.getters.passes;

    //send to backend
    let service = new OrderService();
    context.commit("updateStatus", "preparingPendingOrder");
    return service.submitOrder(order).then(result => {
      if (result && result.status && result.status == "500") {
        context.commit("updateStatus", "creatingPendingOrderFailed");
      }
      //handle any validation errors
      else if (result.status === "validationErrors") {
        context.commit("updateStatus", "validationErrors");
      } else if (result.paymentInfo.htmL5RedirectUrl) {
        //set r1stoken of pending order
        context.commit("updateOrder", {
          name: "r1stoken",
          value: result.r1stoken
        });
        //set paymentToken of pending order
        context.commit("updateOrder", {
          name: "paymentToken",
          value: result.paymentInfo.token
        });
        //set reference_number of pending order
        context.commit("updateOrder", {
          name: "referenceNumber",
          value: result.referenceNumber
        });
        //Ready to send user to CCP
        context.commit("updatePaymentUrl", result.paymentInfo.htmL5RedirectUrl);
        context.commit("updateStatus", "pendingPayment");
      } else {
        context.commit("updateStatus", "creatingPendingOrderFailed");
      }
    });
  },
  returnFromPurchase(context, retryCount) {
    if (!retryCount) {
      retryCount = 0;
    }
    //get order status
    let service = new OrderService();
    service
      .getOrderStatus(
        context.getters.orderDetails.paymentToken,
        context.getters.orderDetails.r1stoken,
        context.getters.orderDetails.referenceNumber
      )
      .then(result => {
        let status = "unknownReturnFromPayment";
        if (result.message == "Error validating payment") {
          status = "pendingRecGovUpdate";
        } else if (
          //TODO fix if status is added back in
          // result &&
          // result.order &&
          // result.order.reservations &&
          // result.order.reservations[0].status == "COMPLETED"
          result &&
          result.reservations &&
          result.reservations.length > 0
        ) {
          status = "complete";
          //Set  data
          // context.commit("updateOrder", {
          //   name: "creditCard",
          //   value: result.transactions[0].card_last_four
          // });
          context.commit("updateOrder", {
            name: "orderDate",
            value: moment(result.order_date).format("MM/DD/YYYY")
          });
          context.commit("updateOrder", {
            name: "orderID",
            value: result.order_id
          });
          context.commit("updateOrder", {
            name: "totalCost",
            value: result.total
          });
          context.commit("updateOrder", {
            name: "last4cc",
            value: result.transactions[0].card_last_four
          });
          context.commit("updateOrder", {
            name: "deliveryEmail",
            value: context.getters.orderDetails.deliveryEmail
          });
          for (let i = 0; i < result.reservations.length; i++) {
            let reservation = result.reservations[i];
            let pass = context.getters.passes.find(pass => {
              if (
                reservation.order_details.pass_holder ==
                  pass.firstname + " " + pass.lastname &&
                moment(
                  reservation.order_details.valid_from,
                  "YYYY-MM-DD"
                ).format("MM/DD/YYYY") ==
                  moment(pass["start-date"], "MM/DD/YYYY").format(
                    "MM/DD/YYYY"
                  ) &&
                reservation.total * 100000 == pass.price
              ) {
                return pass;
              }
            });
            context.commit("updatePass", {
              pass: pass,
              name: "passUrl",
              value: result.reservations[i].order_details.download_url
            });
            context.commit("updatePass", {
              pass: pass,
              name: "appleWalletUrl",
              value: result.reservations[i].order_details.pkpass_url
            });
            context.commit("updatePass", {
              pass: pass,
              name: "passid",
              value: result.reservations[i].order_details.pass_id
            });
          }
        }
        context.commit("updateStatus", status);
        //orderStatus.status values:
        //pendingPayment: user has not completed payment
        //pendingRecGovUpdate: payment is complete, but order is not marked complete in Rec.gov
        //complete: payment is complete and rec.gov is up-to-date
        switch (status) {
          case "pendingPayment": {
            //handle incomplete payment - redirect user back to payment page
            window.location = context.getters.paymentUrl;
            break;
          }
          case "pendingRecGovUpdate": {
            //try 10 times to get status
            if (retryCount < 9) {
              context.dispatch("returnFromPurchase", retryCount + 1);
            } else {
              context.commit("updateStatus", "unableToObtainSuccessfulStatus");
            }
            //handle successful payment - keep querying for 5 seconds looking for completed status and pass
            break;
          }
          case "complete": {
            //show receipt with pass
            //this.$router.push({ name: "receipt" });
            break;
          }
        }
      });

    //show receipt without pass

    // context.commit("updateOrder", {
    //   name: "orderID",
    //   value: "XDEGDA"
    // });
    // context.commit("updateOrder", {
    //   name: "orderDate",
    //   value: Date.now()
    // });
    // context.commit("updateOrder", {
    //   name: "totalCost",
    //   value: context.getters.totalPrice
    // });
    // context.commit("updateOrder", {
    //   name: "creditCard",
    //   value: "*1111"
    // });
  },
  // eslint-disable-next-line
  validate(state) {

  },

};

const mutations = {
  addPassToCart(state, pass) {
    pass.id = Date.now() + Math.floor(Math.random() * 1000).toString();
    state.passes.push(pass);
    if (state.siteId === 0) {
      state.siteId = pass.siteId;
    }
  },
  removePassFromCart(state, passId) {
    state.passes = state.passes.filter(item => item.id != passId);
  },
  setSiteId(state, siteId) {
    state.siteId = siteId;
  },
  updateOrder(state, field) {
    Vue.set(state.orderDetails, field.name, field.value);
  },
  updateSiteName(state, siteName) {
    state.siteName = siteName;
  },
  updateAgencyName(state, agencyName) {
    state.agencyName = agencyName;
  },
  updateStatus(state, status) {
    state.status = status;
  },
  updatePaymentUrl(state, url) {
    state.paymentUrl = url;
  },
  clearAllState(state) {
    state.siteId = 0;
    state.passes = [];
    state.siteName = "";
    state.agencyName = "";
    state.orderDetails = {};
    state.status = "not started";
    state.paymentUrl = "";
  },
  updatePass(state, fieldWithPass) {
    Vue.set(fieldWithPass.pass, fieldWithPass.name, fieldWithPass.value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
